<template>
	<div class="kbBox" v-loading.fullscreen.lock="fullscreenLoading">
		<div class="kbTit">
			<div class="kbFanh" @click="fhKeben">
				<i class="el-icon-arrow-left"></i>
				返回单词簿
			</div>
			<div class="kbTjRig">
				<div class="kbTj" @click="tabFlag = 2" v-show="tabFlag == 1">
					<img src="@/assets/img/编组 (13).png" alt="" />
					查看单词
				</div>
				<div class="kbTj" @click="tabFlag = 1" v-show="tabFlag == 2">测试详情</div>
			</div>
		</div>
		<div class="kbCont" v-show="tabFlag == 2">
			<div class="danciPtop">
				<i class="el-icon-tickets"></i>
				单词簿编号：{{ dcData.name }}
			</div>
			<div class="cihuiCont">
				<div class="cihuiItem" v-for="(item, index) in dcData.yydWordsList" :key="index">
					<div class="cihuiItemLef">
						<div class="fgP">
							<h2 v-if="item.type != 2">{{ item.words }}</h2>
							<p v-if="item.type == 2">{{ item.sentence ? item.sentence : item.words }}</p>
							<p v-if="item.type != 2">{{ item.phoneticMark }}</p>
							<img src="@/assets/img/编组 10.png" v-show="!item.audioFlag" @click="ypBtn(item)" alt="" />
							<img src="@/assets/img/bf.svg" v-show="item.audioFlag" alt="" />
						</div>
						<p v-if="item.type != 3">释义：{{ item.partSpeech ? item.partSpeech + '.' : '' }}{{ item.paraphrase }}</p>
						<div class="ljBox" v-if="item.type == 3">
							例句：
							<span v-html="item.sentence"></span>
						</div>
						<p v-if="item.type == 3">语篇新义：{{ item.oldPartSpeech }}.{{ item.oldParaphrase }}</p>
						<p v-if="item.type == 3">常用语义：{{ item.partSpeech }}.{{ item.paraphrase }}</p>
					</div>
					<div class="cihuiItemRig" v-if="item.type == 1 || item.type == 0">
						<div class="cihuiItemRigT">
							<div class="cihuiItemRigTBtn" :class="`cihuiItemRigTBtn${index + 1}`" v-for="(item, index) in item.classificationNames?.split(',')" :key="index">
								{{ item }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="kbCont" v-show="tabFlag == 1">
			<el-table ref="multipleTable" :data="tableData" header-row-class-name="btClass" tooltip-effect="dark" style="width: 100%">
				<el-table-column align="center" prop="createNickName" label="姓名"></el-table-column>
				<el-table-column align="center" label="测试时间">
					<template slot-scope="scope">
						<div>
							{{ scope.row.createTime | momentYR('YYYY年MM月DD日') }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="正确数">
					<template slot-scope="scope">
						<div class="dfIcon">
							<img src="@/assets/img/zq.svg" alt="" />
							{{ scope.row.rightNum || 0 }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="错误数">
					<template slot-scope="scope">
						<div class="dfIcon dfIcon1">
							<img src="@/assets/img/cwu.svg" alt="" />
							{{ scope.row.wrongNum || 0 }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="wwNum" label="测试结果">
					<template slot-scope="scope">
						<div class="jgBtn jgBtn1" v-if="scope.row.status == 1 || scope.row.status === null">不通过</div>
						<div class="jgBtn" v-else>通过</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import dialogBox from '@/components/pubComponents/dialogBox';
import axios from 'axios';
export default {
	name: 'danciPDec',
	data() {
		return {
			tabFlag: 1,
			fullscreenLoading: false,
			tableData: [],
			dcData: {},
			myChart1: '',
			myChart2: '',
			dcFlag: 1
		};
	},
	props: ['dcbId'],
	components: {
		dialogBox
	},
	methods: {
		ypBtn(item) {
			console.log(item, 9999);
			this.fullscreenLoading = true;
			item.audioFlag = true;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: item.audioFileId,
						clientType: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						axios({
							method: 'get',
							url: res.msg,
							// timeout: 600000, // 请求超时时间，数据量多后台响应慢的情况可以调大点，没生效的话可能是vue.config.js里的配置影响了
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							if (red && red.data) {
								const blob = new Blob([red.data], { type: 'audio/mpeg' });
								item.questionAudioFilePath = URL.createObjectURL(blob);
								this.$audio.init(URL.createObjectURL(blob), (r) => {
									item.audioFlag = false;
								});
								this.$nextTick((r) => {
									this.$audio.play();
								});
							} else {
								item.audioFlag = false;
							}
						});
					} else {
						item.audioFlag = false;
					}
				});
		},
		fhKeben() {
			console.log(222);
			this.$emit('fhBtn', 'danciP');
		},
		init() {
			console.log(this.dcbId, 99999);
			this.fullscreenLoading = true;
			this.$http.get(`api/app/yydWordsGroup/${this.dcbId}`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					res.data.yydWordsList.forEach((item) => {
						item.audioFlag = false;
					});
					this.dcData = res.data || [];
				}
			});
			this.$http.get(`api/app/yydGroupWordsRecord/list/${this.dcbId}`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					this.tableData = res.rows || [];
				}
			});
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
::v-deep .btClass {
	.cell {
		font-size: 14px !important;
		color: #000000 !important;
		font-weight: bold !important;
	}
}
.kbBox {
	.kbTit {
		height: 80px;
		border-bottom: 1px solid #eeeff2;
		display: flex;
		align-items: center;
		padding: 0 26px 0 16px;
		justify-content: space-between;
		.kbFanh {
			cursor: pointer;
		}
		.kbTj {
			display: flex;
			align-items: center;
			font-size: 14px;
			cursor: pointer;
			color: #000000;
			line-height: 1;
			img {
				width: 22px;
				height: 22px;
				margin-right: 4px;
			}
			i {
				margin-right: 4px;
				font-size: 16px;
			}
		}
	}
	.kbTjRig {
		display: flex;
		align-items: center;
		.kbTj {
			width: 90px;
			height: 30px;
			background: #1d7b3a;
			border: 1px solid #1d7b3a;
			color: #fff;
			border-radius: 4px;
			display: flex;
			justify-content: center;
			align-items: center;
			img {
				width: 18px;
				height: 14px;
				margin-right: 4px;
			}
		}
	}
}
.dfIcon {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #1d7b3a;
	font-size: 14px;
	img {
		margin-right: 4px;
		width: 14px;
		height: 14px;
	}
}
.dfIcon1 {
	color: #fa4a1b;
}
.tjBoxs {
	display: flex;
}
.banjJcBtn {
	width: 90px;
	height: 30px;
	background: #fa4a1b;
	border-radius: 4px;
	font-size: 14px;
	color: #ffffff !important;
	margin-left: 18px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	i {
		font-size: 16px;
		margin-right: 4px;
	}
}
.jgBtn {
	width: 52px;
	height: 26px;
	background: #e8fbee;
	border-radius: 4px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;
	color: #1d7b3a;
	margin: 0 auto;
}
.jgBtn1 {
	background: #fef0ec;
	color: #fa4a1b;
}
.kbCont {
	.danciPtop {
		height: 59px;
		border-bottom: 1px solid #eeeff2;
		padding-left: 18px;
		font-weight: bold;
		font-size: 14px;
		display: flex;
		align-items: center;
		line-height: 1;
		i {
			font-size: 18px;
			margin-right: 5px;
		}
	}
}
.cihuiCont {
	margin-bottom: 18px;
	padding: 0 22px;
	.cihuiItem {
		padding: 18px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #f8f8f8;
		&:last-of-type {
			border-bottom: none;
		}
		.cihuiItemRig {
			.cihuiItemRigT {
				display: flex;
				margin-bottom: 8px;
				.cihuiItemRigTBtn {
					padding: 5px 12px;
					font-size: 12px;
					border-radius: 4px;
					margin-left: 10px;
					cursor: pointer;
				}
				.cihuiItemRigTBtn1 {
					background: #ffeef8;
					color: #d7198b;
				}
				.cihuiItemRigTBtn2 {
					background: #eef6ff;
					color: #1f6cf5;
				}
				.cihuiItemRigTBtn3 {
					background: #fff4ee;
					color: #f07c10;
				}
			}
			p {
				color: #878787;
				margin-top: 8px;
				font-size: 12px;
				text-align: right;
			}
		}
		.cihuiItemLef {
			display: flex;
			flex-direction: column;
			justify-content: center;
			font-size: 14px;
			color: #000000;

			.fgP {
				display: flex;
				align-items: center;
				line-height: 1;
			}

			h2 {
				font-size: 24px;
				color: #000000;
				margin: 0 11px 0 0;
				font-weight: bold;
			}
			> p {
				color: #1d7b3a;
				margin-top: 10px;
			}
			.ljBox {
				margin-top: 10px;
			}
			img {
				width: 21px;
				height: 21px;
				margin: 0 15px;
				cursor: pointer;
			}
			.ass {
				color: #000000;
				span {
					color: #1d7b3a;
				}
			}
		}
	}
}
</style>
